// Types de flotte et de scénario (MissionGlobal) autorisés par les réglages de modules d'une
// enseigne (BLF037, RG-ACC-049 ; même règle que la v2, glimpse-2/app/utils/tenant-modules.ts).
// - Flotte : libre si fleet_on ; formation si en plus formation_on ; couverture si en plus
//   coverage_on ET smartplanning_on (la grille d'une flotte Couverture vient d'un scénario
//   Smart Planning Couverture).
// - Smart Planning : simulation si smartplanning_on ; couverture / formation selon l'option.
import { FleetType } from '@/enum/FleetType'
import { MissionGlobalType } from '@/enum/MissionGlobalType'
import { IEnseigneConfig } from '@/models/alodb/AloDbEnseigne'

export function allowedFleetTypes(config: IEnseigneConfig): FleetType[] {
  if (!config.fleet_on) return []
  const types = [FleetType.FREE]
  if (config.coverage_on && config.smartplanning_on) types.push(FleetType.COVERAGE)
  if (config.formation_on) types.push(FleetType.FORMATION)
  return types
}

export function allowedMissionGlobalTypes(config: IEnseigneConfig): MissionGlobalType[] {
  if (!config.smartplanning_on) return []
  const types = [MissionGlobalType.SIMULATION]
  if (config.coverage_on) types.push(MissionGlobalType.COVERAGE)
  if (config.formation_on) types.push(MissionGlobalType.FORMATION)
  return types
}

// Type absent : seul le module compte.
export function isFleetTypeAllowed(config: IEnseigneConfig, typ: number | null | undefined): boolean {
  if (typ == null) return config.fleet_on
  return allowedFleetTypes(config).includes(typ)
}

export function isMissionGlobalTypeAllowed(config: IEnseigneConfig, typ: number | null | undefined): boolean {
  if (typ == null) return config.smartplanning_on
  return allowedMissionGlobalTypes(config).includes(typ)
}

// Rejet des actions d'ouverture d'un détail quand l'objet est refusé pour son enseigne : la page
// affiche « introuvable » et revient à la liste (RG-ACC-050).
export const DETAIL_REFUSED = 'detail-refused'
